const allPromos = [
    {
        sportkey: "golf",
        name: "The Open Special",
        startsOn: "2026-07-12",
        expires: "2026-07-20",
        monthly:{
            code: "ANALYZERM26",
            description: "7 days free then $2.99/month",
            normalPrice: "(Normally $9.99/month)",
            globalTag: "7 days free"
        },
        yearly:{
            code: "ANALYZER26",
            description: "30 days free then $24.99/year",
            normalPrice: "(Normally 7 days free then $79.99/year)",
            globalTag: "30 days free"
        },
        weekly:{
            code: "ANALYZERW26",
            description: "3 days free then $0.99/week",
            normalPrice: "(Not normally available)",
            globalTag: "3 days free"
        }
    },
    {
        sportkey: "global",
        name: "The Open Special",
        startsOn: "2026-07-12",
        expires: "2026-07-20",
        monthly:{
            code: "ANALYZERM26",
            description: "7 days free then $2.99/month",
            normalPrice: "(Normally $9.99/month)",
            globalTag: "7 days free"
        },
        yearly:{
            code: "ANALYZER26",
            description: "30 days free then $24.99/year",
            normalPrice: "(Normally 7 days free then $79.99/year)",
            globalTag: "30 days free"
        },
        weekly:{
            code: "ANALYZERW26",
            description: "3 days free then $0.99/week",
            normalPrice: "(Not normally available)",
            globalTag: "3 days free"
        }
    },
    {
        sportkey: "cricket_off",
        name: "New Season Special",
        startsOn: "2026-05-01",
        expires: "2026-05-31",
        monthly:{
            code: "ANALYZERM26",
            description: "7 days free then $2.99/month",
            normalPrice: "(Normally $9.99/month)",
            globalTag: "7 days free"
        },
        yearly:{
            code: "ANALYZER26",
            description: "30 days free then $24.99/year",
            normalPrice: "(Normally 7 days free then $79.99/year)",
            globalTag: "30 days free"
        },
        weekly:{
            code: "ANALYZERW26",
            description: "3 days free then $0.99/week",
            normalPrice: "(Not normally available)",
            globalTag: "3 days free"
        }
    }
]

const getPromo = (key) => {
    const promo = allPromos.find(p => p.sportkey === key);

    if (promo && new Date(promo.startsOn) <= new Date() && new Date(promo.expires) > new Date()) {
        return promo;
    }

    return null;
}


export {getPromo}